import { DocumentNode, useMutation } from '@apollo/client'
import { EditTestSession, EditTestSessionVariables } from '../../types'
import { EDIT_TEST_SESSION } from './operations'

interface Props {
  queryToRefetch?: DocumentNode
  testSessionId?: string
  skipResult?: boolean
}

export const useEditTestSession = ({ queryToRefetch, testSessionId, skipResult = false }: Props) =>
  useMutation<EditTestSession, EditTestSessionVariables>(
    EDIT_TEST_SESSION,
    queryToRefetch
      ? {
          refetchQueries: [
            {
              query: queryToRefetch,
              variables: { id: testSessionId, skipResult },
            },
          ],
          awaitRefetchQueries: true,
        }
      : {}
  )
